import unreadMsgStore from '@/stores/unreadMsg';
import { mockMessageId } from '@/utils/historyHandler';
import { reportAgentMessage } from '@/utils/reportAgentMessage';
import { GetUnreadMsgLimit } from '@/utils/constants';

export default async function getUnreadMessage() {
  const historyStore = (await import('@/stores/history')).default;
  const formatHistoryMessages = (await import('@/utils/formatHistoryMessages')).default;
  const data = await historyStore.fetchChatHistory({
    // @ts-ignore
    need_latest_unread_agent_msg: true,
    limit: GetUnreadMsgLimit,
  });
  let unreadMessages: Array<any> = [];

  if (!(data instanceof Error)) {
    const { messages: formatDataList, beforeMessageId } = formatHistoryMessages(data.messages || []);
    beforeMessageId && historyStore.setBeforeMessageId(beforeMessageId);

    if (formatDataList.length) {
      reportAgentMessage(formatDataList[formatDataList.length - 1]?.message_id);

      unreadMessages = [
        ...formatDataList,
      ];

      // 已经没有更多未读
      // 就显示未读数量
      if (data.has_more === false) {
        unreadMessages.unshift({
          message_id: mockMessageId(),
          from: 'system',
          type: 'UnreadMessages',
          data: { num: formatDataList.length },
        });
      }
    }
  }

  unreadMsgStore.updateMessageList(unreadMessages);

  return { unreadMessages };
}
